import { TableCellProps, TableCell } from "@/components/Table";
import { FC, PropsWithChildren } from "react";

export const TableCellBlock: FC<PropsWithChildren<TableCellProps>> = ({
  children,
  ...props
}) => <TableCell {...props}>{children}</TableCell>;
